import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import studioImage from '../images/studio.jpg';
import { useLanguage } from '../i18n/LanguageContext';

const About = () => {
  const { t } = useLanguage();
  const points = t('about.points');

  return (
    <section id="about" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        
        <motion.div 
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="aspect-[4/5] rounded-tl-[100px] rounded-br-[100px] overflow-hidden">
            <img 
              src={studioImage} 
              alt={t('about.imageAlt')}
              className="w-full h-full object-cover"
            />
          </div>
          {/* Decorative element */}
          <div className="absolute -z-10 top-10 -right-10 w-full h-full border-2 border-brand-sand rounded-tl-[100px] rounded-br-[100px]"></div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-6">
            {t('about.title')}
          </h2>
          <p className="text-brand-muted text-lg mb-8 leading-relaxed font-light">
            {t('about.body')}
          </p>
          
          <ul className="space-y-4">
            {points.map((point, index) => (
              <li key={index} className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-sand flex items-center justify-center text-brand-taupe">
                  <SafeIcon icon={FiCheck} className="w-3.5 h-3.5" />
                </div>
                <span className="text-brand-dark">{point}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10">
            <img 
              src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?auto=format&fit=crop&q=80&w=200" 
              alt="Founder signature placeholder" 
              className="h-16 opacity-50 grayscale mix-blend-multiply hidden" // Optional signature placeholder
            />
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default About;
